import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";

import defaultCardImage from "../../images/shield-icon.svg";

import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";

import SupportIconImage from "../../images/support-icon.svg";
import ShieldIconImage from "../../images/shield-icon.svg";
import CustomizeIconImage from "../../images/customize-icon.svg";
import FastIconImage from "../../images/fast-icon.svg";
import ReliableIconImage from "../../images/reliable-icon.svg";
import SimpleIconImage from "../../images/simple-icon.svg";
import { BiTimer, BiMessageSquareCheck } from "react-icons/bi";
import { HiOutlineArrowsExpand } from "react-icons/hi";

const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;
const Heading = tw(SectionHeading)`w-full leading-none`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 border-2 border-dashed border-primary-500 rounded-lg mt-12`}
  .imageContainer {
    ${tw`border-2 border-primary-500 text-center rounded-full p-4 flex-shrink-0 relative`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .textContainer {
    ${tw`mt-6 text-center`}
  }

  .title {
    ${tw`mt-2 font-bold text-xl leading-none text-primary-500`}
  }
  .subtitle {
    ${tw`mt-2 font-bold text-lg leading-none `}
  }

  .description {
    ${tw`mt-3 font-semibold text-secondary-100 text-sm leading-loose`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default () => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const cards = [
    {
      imageSrc: ShieldIconImage,
      icon: <HiOutlineArrowsExpand tw="w-8 h-8 text-primary-500" />,
      title: "Informed & Involved",
      subtitle: "Advanced automation for campaigns and journeys",
      description:
        "Attentive is one of the only SMS marketing platforms with a seat on the CTIA board and is a member of the CWTA, both of which help shape deliverability rules and regulations across the industry.",
    },
    {
      imageSrc: SupportIconImage,
      icon: <BiMessageSquareCheck tw="w-8 h-8 text-primary-500" />,
      title: "Maintain Compliance",
      subtitle: "Strategic guidance from launch to optimization",
      description:
        "Maintain customer trust and protect your brand from potential risk with Attentive Compliance. Our tools are built in throughout the user flow, so you can run your SMS program with peace of mind.",
    },
    {
      imageSrc: SupportIconImage,
      icon: <BiMessageSquareCheck tw="w-8 h-8 text-primary-500" />,
      title: "Maintain Compliance",
      subtitle: "Strategic guidance from launch to optimization",
      description:
        "Maintain customer trust and protect your brand from potential risk with Attentive Compliance. Our tools are built in throughout the user flow, so you can run your SMS program with peace of mind.",
    },
    // { imageSrc: ReliableIconImage, title: "Product Outreach" },
    // { imageSrc: FastIconImage, title: "PR Campaign" },
    // { imageSrc: SimpleIconImage, title: "Product Expansion" }
  ];

  return (
    <Container id="features">
      <ThreeColumnContainer>
        <Heading>
          {/* <span tw="text-primary-500"> */}
          Partner with the industry-leader in <br /> deliverability
          {/* </span> */}
        </Heading>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer ">
                {card.icon}
                {/* <img src={card.imageSrc || defaultCardImage} alt="" /> */}
              </span>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                {/* <p className="subtitle">{card.subtitle || "Fully Secure"}</p> */}
                <p className="description">
                  {card.description ||
                    "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud. Sic Semper Tyrannis. Neoas Calie artel."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
